var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row item-mobile-galler"},[_c('vue-gallery-slideshow',{staticStyle:{"background-color":"rgba(0, 0, 0, 0.9)","padding-top":"5%"},attrs:{"images":_vm.images,"index":_vm.index},on:{"close":_vm.closePhotoFxn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }